import * as React from "react";
const SvgCountPlusIcon = () => (
  <svg width={27} height={27} fill="none">
    <path
      fill="#4338CA"
      d="M26.15 15H15v11.25h-3.25V15H.65v-3h11.1V.75H15V12h11.15v3Z"
    />
  </svg>
);
export default SvgCountPlusIcon;
